import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import {type EUserRoles } from '../enums/EUserRoles';
import CoreJsonAPIService from './CoreJsonAPIService';

export default class UserManagementCoreService extends CoreJsonAPIService {
  static async userSignup(
    user: Partial<{
      firstName: string;
      lastName: string;
      email: string;
      company: string;
      position?: string;
      requestedRole: EUserRoles;
      termsAccepted: boolean;
      subscribeToMailingList?: boolean;
    }>
  ) {
    return await super.post<any>(
      EDjangoAppsEndpoints.userManagement,
      'public/sign-up',
      user
    );
  }
}